/* ==========================================================================
   Human Initiative - Fundraising Platform JavaScript
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Animated Counter ---------- */
  function animateCounter(el) {
    const target = parseFloat(el.dataset.target) || 0;
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    const duration = 2000;
    const start = performance.now();

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(eased * target);

      el.textContent = prefix + current.toLocaleString() + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }

  /* ---------- Scroll Animation Observer ---------- */
  function initScrollAnimations() {
    var elements = document.querySelectorAll('.hi-animate');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hi-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- Counter Observer ---------- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !entry.target.dataset.counted) {
            entry.target.dataset.counted = 'true';
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    counters.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- Donation Tier Selection ---------- */
  function initDonationTiers() {
    document.querySelectorAll('.hi-donate__tiers').forEach(function (container) {
      var tiers = container.querySelectorAll('.hi-donate__tier');
      var form = container.closest('.hi-donate')?.querySelector('form') || container.closest('section')?.querySelector('form');
      var customInput = container.closest('.hi-donate__container')?.querySelector('.hi-donate__custom-input') ||
                        container.closest('section')?.querySelector('#custom-amount');
      var hiddenInput = form?.querySelector('[name="properties[Donation Amount]"]') ||
                        form?.querySelector('#donation-value');
      var quantityInput = form?.querySelector('[name="quantity"]');

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () {
          tiers.forEach(function (t) { t.classList.remove('active'); });
          tier.classList.add('active');

          var amount = tier.dataset.amount;
          if (customInput) customInput.value = '';
          if (hiddenInput) hiddenInput.value = amount;
          if (quantityInput) quantityInput.value = amount;
        });
      });

      if (customInput) {
        customInput.addEventListener('input', function () {
          tiers.forEach(function (t) { t.classList.remove('active'); });
          if (hiddenInput) hiddenInput.value = customInput.value;
          if (quantityInput) quantityInput.value = customInput.value;
        });

        customInput.addEventListener('focus', function () {
          tiers.forEach(function (t) { t.classList.remove('active'); });
        });
      }
    });
  }

  /* ---------- Donation Tabs (One-time / Monthly) ---------- */
  function initDonationTabs() {
    document.querySelectorAll('.hi-donate__tabs').forEach(function (tabsContainer) {
      var tabs = tabsContainer.querySelectorAll('.hi-donate__tab');
      var section = tabsContainer.closest('section');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('active'); });
          tab.classList.add('active');

          var target = tab.dataset.tab;
          if (section) {
            section.querySelectorAll('[data-tab-content]').forEach(function (content) {
              content.style.display = content.dataset.tabContent === target ? 'block' : 'none';
            });
          }
        });
      });
    });
  }

  /* ---------- Dedication Toggle ---------- */
  function initDedication() {
    document.querySelectorAll('.hi-donate__dedication-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var fields = toggle.closest('.hi-donate__dedication')?.querySelector('.hi-donate__dedication-fields');
        if (fields) {
          fields.classList.toggle('active');
        }
      });
    });
  }

  /* ---------- Recurring Donation Options ---------- */
  function initRecurringOptions() {
    document.querySelectorAll('.hi-recurring__options').forEach(function (container) {
      var options = container.querySelectorAll('.hi-recurring__option');
      var form = container.closest('section')?.querySelector('form');
      var hiddenInput = form?.querySelector('[name="properties[Frequency]"]');

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          options.forEach(function (o) { o.classList.remove('active'); });
          option.classList.add('active');
          if (hiddenInput) hiddenInput.value = option.dataset.frequency;
        });
      });
    });
  }

  /* ---------- Gallery Lightbox ---------- */
  function initLightbox() {
    var lightbox = document.querySelector('.hi-lightbox');
    if (!lightbox) return;

    var lightboxImg = lightbox.querySelector('.hi-lightbox__img');
    var closeBtn = lightbox.querySelector('.hi-lightbox__close');
    var prevBtn = lightbox.querySelector('.hi-lightbox__nav--prev');
    var nextBtn = lightbox.querySelector('.hi-lightbox__nav--next');
    var galleryItems = document.querySelectorAll('.hi-gallery__item');
    var currentIndex = 0;
    var images = [];

    galleryItems.forEach(function (item, index) {
      var img = item.querySelector('img');
      if (img) {
        images.push(img.src);
        item.addEventListener('click', function () {
          currentIndex = index;
          showImage(currentIndex);
          lightbox.classList.add('active');
          document.body.style.overflow = 'hidden';
        });
      }
    });

    function showImage(index) {
      if (lightboxImg && images[index]) {
        lightboxImg.src = images[index];
      }
    }

    function closeLightbox() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        showImage(currentIndex);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        currentIndex = (currentIndex + 1) % images.length;
        showImage(currentIndex);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('active')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
      if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
    });
  }

  /* ---------- Progress Bar Animation ---------- */
  function setFillPercent(bar, percent) {
    var target = Math.max(0, Math.min(100, parseFloat(percent) || 0));
    bar.style.setProperty('--hi-fill', target + '%');
    bar.dataset.width = String(target);
  }

  function initProgressBars() {
    // The width is now authoritatively set by the --hi-fill CSS variable from
    // Liquid (see .hi-progress__fill { width: var(--hi-fill) !important }).
    // This function only exists to reconcile any bars whose inline style was
    // wiped by stale JS in cached pages — it re-reads data-width and re-applies.
    var bars = document.querySelectorAll('.hi-progress__fill');
    bars.forEach(function (bar) {
      if (!bar.style.getPropertyValue('--hi-fill') && bar.dataset.width) {
        setFillPercent(bar, bar.dataset.width);
      }
    });
  }

  /* ---------- Campaign Live Progress Updates ---------- */
  function formatCampaignMoney(cents, locale, currency) {
    var value = Number(cents) / 100;
    try {
      return new Intl.NumberFormat(locale || 'en', {
        style: 'currency',
        currency: currency || 'EUR',
      }).format(value);
    } catch (e) {
      return (currency || '€') + value.toFixed(2);
    }
  }

  function applyCampaignCardData(card, raisedCents) {
    var goal = parseFloat(card.dataset.goal) || 0;
    var prevRaised = parseFloat(card.dataset.raised) || 0;
    var raised = Math.max(0, Math.round(raisedCents));
    if (raised === prevRaised) return;

    var percent = goal > 0 ? Math.min(100, Math.round((raised / goal) * 100)) : 0;
    card.dataset.raised = String(raised);

    var fill = card.querySelector('.hi-progress__fill');
    if (fill) setFillPercent(fill, percent);
    var raisedEl = card.querySelector('[data-raised-display]');
    if (raisedEl) {
      raisedEl.textContent = formatCampaignMoney(raised, card.dataset.locale, card.dataset.currency);
    }
    var pctEl = card.querySelector('[data-percent-display]');
    if (pctEl) pctEl.textContent = percent;
  }

  var campaignFetchCache = {};
  function refreshCampaignCard(card) {
    if (card.dataset.inventoryTracked !== '1') return Promise.resolve();
    var handle = card.dataset.handle;
    if (!handle) return Promise.resolve();

    if (!campaignFetchCache[handle]) {
      campaignFetchCache[handle] = fetch('/products/' + handle + '.js', { cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (data) {
          setTimeout(function () { delete campaignFetchCache[handle]; }, 1000);
          return data;
        });
    }

    return campaignFetchCache[handle].then(function (data) {
      if (!data || !data.variants || !data.variants.length) return;
      var variant = data.variants[0];
      // Only trust live data when inventory has actually gone negative
      // (donations tracked via "continue selling past 0"). A zero or positive
      // inventory from the public products.js endpoint is ambiguous — it may
      // mean "no sales yet" or "field scrubbed for privacy". In either case
      // we must NOT overwrite the server-rendered raised amount.
      if (typeof variant.inventory_quantity !== 'number') return;
      if (variant.inventory_quantity >= 0) return;
      var sold = -variant.inventory_quantity;
      var price = typeof variant.price === 'number' ? variant.price : parseFloat(card.dataset.price) || 0;
      var newRaised = sold * price;
      var prevRaised = parseFloat(card.dataset.raised) || 0;
      // Donations only grow — never regress the bar below its server-rendered value.
      if (newRaised <= prevRaised) return;
      applyCampaignCardData(card, newRaised);
    });
  }

  function refreshAllCampaignCards() {
    var cards = document.querySelectorAll('[data-campaign-card]');
    cards.forEach(function (card) { refreshCampaignCard(card); });
  }

  function initCampaignLiveUpdates() {
    var cards = document.querySelectorAll('[data-campaign-card]');
    if (!cards.length) return;

    refreshAllCampaignCards();

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(refreshAllCampaignCards, 400);
      });
    }
    document.addEventListener('hi:donation:success', function () {
      setTimeout(refreshAllCampaignCards, 400);
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshAllCampaignCards();
    });
  }

  /* ---------- Campaign Filter Tags ---------- */
  function initCampaignFilters() {
    document.querySelectorAll('.hi-campaign-grid__filters').forEach(function (filtersContainer) {
      var filters = filtersContainer.querySelectorAll('.hi-campaign-grid__filter');
      var grid = filtersContainer.closest('section')?.querySelector('.hi-campaign-grid');
      if (!grid) return;
      var cards = grid.querySelectorAll('.hi-campaign-card');

      filters.forEach(function (filter) {
        filter.addEventListener('click', function () {
          filters.forEach(function (f) { f.classList.remove('active'); });
          filter.classList.add('active');

          var tag = filter.dataset.filter;
          cards.forEach(function (card) {
            if (tag === 'all' || card.dataset.tags?.includes(tag)) {
              card.style.display = '';
            } else {
              card.style.display = 'none';
            }
          });
        });
      });
    });
  }

  /* ---------- Smooth Scroll to Donate ---------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = link.getAttribute('href');
        if (targetId === '#') return;
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ---------- Countdown Timer ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var endDate = new Date(el.dataset.countdown).getTime();
      if (isNaN(endDate)) return;

      function update() {
        var now = Date.now();
        var diff = endDate - now;

        if (diff <= 0) {
          el.innerHTML = '<span class="hi-badge hi-badge--danger">Campaign Ended</span>';
          return;
        }

        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);

        var daysEl = el.querySelector('.hi-countdown__days');
        var hoursEl = el.querySelector('.hi-countdown__hours');
        var minsEl = el.querySelector('.hi-countdown__mins');

        if (daysEl) daysEl.textContent = days;
        if (hoursEl) hoursEl.textContent = hours;
        if (minsEl) minsEl.textContent = mins;
      }

      update();
      setInterval(update, 60000);
    });
  }

  /* ---------- Add to Cart via AJAX ---------- */
  function initAjaxCart() {
    document.querySelectorAll('.hi-donate form, .hi-recurring form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var submitBtn = form.querySelector('[type="submit"]');
        var originalText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding...';
        }

        var formData = new FormData(form);
        var data = {};

        // Build the cart payload
        data.id = formData.get('id');
        data.quantity = parseInt(formData.get('quantity')) || 1;
        data.properties = {};

        for (var pair of formData.entries()) {
          if (pair[0].startsWith('properties[')) {
            var key = pair[0].replace('properties[', '').replace(']', '');
            if (pair[1]) data.properties[key] = pair[1];
          }
        }

        fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [data] }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Failed to add to cart');
            return response.json();
          })
          .then(function () {
            if (submitBtn) {
              submitBtn.textContent = 'Added!';
              submitBtn.classList.add('hi-btn--accent');
              setTimeout(function () {
                submitBtn.textContent = originalText;
                submitBtn.disabled = false;
                submitBtn.classList.remove('hi-btn--accent');
              }, 2000);
            }
            // Trigger cart drawer if available
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('hi:donation:success'));
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              fetch('/cart.js')
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  var countEl = document.querySelector('.cart-count-bubble span');
                  if (countEl) countEl.textContent = cart.item_count;
                });
            }
          })
          .catch(function () {
            if (submitBtn) {
              submitBtn.textContent = 'Error - Try Again';
              submitBtn.disabled = false;
              setTimeout(function () {
                submitBtn.textContent = originalText;
              }, 3000);
            }
          });
      });
    });
  }

  /* ---------- Initialize Everything ---------- */
  function init() {
    initScrollAnimations();
    initCounters();
    initDonationTiers();
    initDonationTabs();
    initDedication();
    initRecurringOptions();
    initLightbox();
    initProgressBars();
    initCampaignLiveUpdates();
    initCampaignFilters();
    initSmoothScroll();
    initCountdown();
    initAjaxCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section events (Theme Editor)
  document.addEventListener('shopify:section:load', init);
})();
